<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor"><i class="text-secondary fa-solid fa-truck"></i> Añadir referencias a entrada </h3>
        <h3 class="text-themecolor monospace">
            Desde playa {{entrada.ubiPlaya! | mask: '00.00.00.00.00.00'}}
        </h3>
    </div>
</div>

<div class="row animated fadeIn fast">


    <!-- Formulario -->
    <div class="col-12">
        <div class="card border border-info rounded">

            <div class="card-body p-2 ">

                <form class="form"
                      [formGroup]="entradaForm"
                      [ngClass]="{'form-horizontal': true}">

                    <!-- Artículos del palé en diferentes ubicaciones -->
                    <div class="row">


                        <!-- ean -->
                        <div class=" col-6">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado.ean && f['ean'].errors }">
                                <label class="form-control-label">Ean:</label>
                                <input #txtEan
                                       type="text"
                                       formControlName="ean"
                                       (blur)="toUpper('ean')"
                                       (change)="validaEan()"
                                       class="form-control"
                                       [ngClass]="{ 'form-control-danger': enviado.ean && f['ean'].errors }">

                                <div *ngIf="enviado.ean && f['ean'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['ean'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['ean'].errors['maxlength']">Como máximo 150 caracteres</div>
                                    <div *ngIf="entradaForm.get('ean')?.errors?.['apiError']">{{entradaForm.get('ean')?.errors?.['apiError'] }}</div>
                                </div>
                            </div>
                        </div>



                        <!-- cantidad -->
                        <div class="col-3">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado.cantidad && f['cantidad'].errors }">
                                <label class="form-control-label"> Cantidad: </label>
                                <input type="text"
                                       formControlName="cantidad"
                                       (change)="validaCantidad()"
                                       class="form-control"
                                       maxlength="13">

                                <div *ngIf="enviado.cantidad &&  f['cantidad'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['cantidad'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['cantidad'].errors['min']">Como mínimo 1</div>
                                    <div *ngIf="f['cantidad'].errors['max']">Como máximo 99.999</div>
                                </div>

                            </div>
                        </div>

                        <!-- pale -->
                        <div class="col-3 text-center">
                            <label *ngIf="paleSelected !== null"
                                   class="form-control-label text-muted"> Separación</label>
                            <br>
                            <h1 *ngIf="paleSelected !== null"
                                class="btn text-white font30 px-2 px-sm-3"
                                [ngClass]="paleLlenoFlag ? 'btn-warning' : 'btn-primary'">
                                {{paleSelected}}
                            </h1>
                        </div>

                    </div><!-- row -->

                    <!-- sku y descripción -->
                    <div *ngIf="articulo.sku"
                         class="row">
                        <div class="col-12">
                            <h6 class="card-title text-info">{{articulo.sku}} - {{articulo.descripcion}}</h6>
                        </div>
                    </div>


                    <!-- Botones -->
                    <div class="row">
                        <div class="col-6">
                            <button type="button"
                                    [disabled]="!articulo.id || loading"
                                    class="btn btn-outline-secondar px-2 px-sm-3"
                                    (click)="paleLleno()">
                                Palé lleno <span *ngIf="paleLlenoFlag"><i class="fa fa-check"></i> </span>
                            </button>
                        </div>
                        <div class="col-6 text-right">
                            <button type="button"
                                    [disabled]="!articulo.id || loading"
                                    class="btn btn-success px-2 px-sm-3"
                                    (click)="enviar()">
                                Añadir
                            </button>
                        </div>
                    </div>


                </form>

            </div>


        </div> <!-- card -->
    </div> <!-- col-lg-12 -->



    <!-- Lista de palés artículos -->
    <div class="col-md-12 col-xs-12 animated fadeIn fast">

        <div class="card border border-info rounded">

            <div class="card-body">
                <button [disabled]="loading"
                        (click)="recargarDatos()"
                        class="btn btn-outline-info float-right">
                    &nbsp;<i class="fa fa-sync-alt"
                       [class.fa-spin]="loading"></i>&nbsp;
                </button>
                <h4 class="card-title text-info">{{entrada.cliNombre}} - {{entrada.albaran}}</h4>
                <h6 class="card-subtitle">Referencias en separaciones</h6>
                <div class="bootstrap-table">
                    <div class="table-responsive">

                        <div class="table-responsive">
                            <table class="table table-sm table-bordered fs-10">

                                <thead>
                                    <tr>
                                        <th>PALÉ</th>
                                        <th>EAN</th>
                                        <th>SKU</th>
                                        <th style="text-align: center;">Cant.</th>
                                    </tr>
                                </thead>

                                <!-- Si hay detall y no está ubicado, mostrarlo -->
                                <tbody *ngIf="entrada.detall">
                                    <ng-container *ngFor="let lin of entrada.detall; let i = index">

                                        <tr>

                                            <td>
                                                <!-- Select palé -->
                                                <span *ngIf="i == 0 || lin.pale != entrada.detall[i-1].pale">
                                                    <a (click)="'#'"
                                                       title="Separar en palé {{ lin.pale}}"
                                                       class="btn btn-primary text-white"> {{ lin.pale}}</a>
                                                </span>
                                            </td>

                                            <td>
                                                {{ lin.artEan }}
                                                <span *ngIf="lin.swDefectuoso == Const.DEFECTUOSO">
                                                    <i title="Defectuoso"
                                                       class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                                                </span>
                                            </td>
                                            <td>
                                                <h6 class="card-title text-secondary">{{ lin.artSku }}</h6>
                                            </td>
                                            <td style="text-align: right;">
                                                <div class="monospace">
                                                    {{lin.cantidad | number: '0.0-0':'es'}}
                                                </div>
                                            </td>

                                        </tr>

                                    </ng-container>
                                </tbody>

                            </table>
                        </div>


                    </div>
                </div>
            </div>

        </div>

    </div>


    <!-- Histórico de escaneos (Acordeón) -->
    <div class="col-12 mt-2"
         *ngIf="dataHistotico.length > 0">
        <div id="accordionHistorico">
            <div class="card border border-secondary rounded">
                <div class="card-header p-0"
                     id="headingHistorico">
                    <h5 class="mb-0">
                        <button class="btn btn-link btn-block text-left text-secondary"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseHistorico"
                                aria-expanded="false"
                                aria-controls="collapseHistorico">
                            <i class="fa fa-history mr-2"></i> Histórico de escaneos ({{dataHistotico.length}})
                        </button>
                    </h5>
                </div>

                <div id="collapseHistorico"
                     class="collapse"
                     aria-labelledby="headingHistorico"
                     data-parent="#accordionHistorico">
                    <div class="card-body p-2">
                        <div class="table-responsive">
                            <table class="table table-sm table-striped fs-10 mb-0">
                                <thead>
                                    <tr>
                                        <th>Palé</th>
                                        <th>EAN</th>
                                        <th>SKU</th>
                                        <th style="text-align: right;">Cant.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataHistotico">
                                        <td>{{item.pale}}</td>
                                        <td>{{item.articulo.ean}}</td>
                                        <td>{{item.articulo.sku}}</td>
                                        <td style="text-align: right;">{{item.cantidad | number: '0.0-0':'es'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>